import { useEffect } from 'react';
import { useParams } from 'react-router-dom';

const Redirect = ({ to }) => {
  const params = useParams();
  const resolvedPath = Object.keys(params).reduce(
    (path, param) => path.replace(`:${param}`, params[param]),
    to,
  );

  useEffect(() => {
    window.location.href = resolvedPath;
  }, [resolvedPath]);

  return null;
};

export default Redirect;
